import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KlmLayoutRoutingModule } from './klm-layout-routing.module';
import { KlmDashboardComponent } from '../klm-dashboard/klm-dashboard.component';
import { KlmSidebarComponent } from './klm-sidebar/klm-sidebar.component';
import { KlmHeaderComponent } from './klm-header/klm-header.component';
import { KlmFooterComponent } from './klm-footer/klm-footer.component';
import { KlmLayoutsComponent } from './klm-layouts.component';
import { SharedModule } from '../../../app/shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgChartsModule } from 'ng2-charts';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HierachyComponent } from '../setting/hierachy/hierachy.component';
import { FieldComponent } from '../setting/field/field.component';
import { AdminstrationComponent } from '../adminstration/adminstration.component';
import { DataAssignmentComponent } from '../adminstration/data-assignment/data-assignment.component';
import { RoleComponent } from '../adminstration/role/role.component';
import { UserComponent } from '../adminstration/user/user.component';
import { WorkFlowComponent } from '../adminstration/work-flow/work-flow.component';
import { CodeValueComponent } from '../setting/code-value/code-value.component';
import { SettingComponent } from '../setting/setting.component';
import { MatRadioModule } from '@angular/material/radio';

import { MatDialogModule } from '@angular/material/dialog';
import { KlmBookingComponent } from '../klm-booking/klm-booking.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CanvasJSAngularChartsModule } from '@canvasjs/angular-charts';

@NgModule({
  declarations: [
    KlmDashboardComponent,
    KlmSidebarComponent,
    KlmHeaderComponent,
    KlmFooterComponent,
    KlmLayoutsComponent,
    HierachyComponent,
    AdminstrationComponent,
    SettingComponent,
    DataAssignmentComponent,
    RoleComponent,
    UserComponent,
    WorkFlowComponent,
    CodeValueComponent,
    FieldComponent,
    KlmBookingComponent,
  ],
  exports: [
   KlmHeaderComponent,
   KlmFooterComponent,
   KlmSidebarComponent,
   KlmLayoutsComponent,

  ],
  imports: [
    CommonModule,
    KlmLayoutRoutingModule,
    MatRadioModule,
    SharedModule,
    MatDialogModule, 
    NgSelectModule,
    NgChartsModule,
    FileUploadModule,
    MatInputModule,
    // NgbModule,
    MatSlideToggleModule,
    FormsModule,
    MatCardModule,
    // NgtreegridModule,
    MatStepperModule,
    MatCheckboxModule,
    MatExpansionModule,
    NgxSpinnerModule,
    HttpClientModule,
    MatSnackBarModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    NgApexchartsModule,
    ReactiveFormsModule,
    MatTabsModule,
    RouterModule,
  
  
    NgxChartsModule,
    CanvasJSAngularChartsModule,

  ]
})
export class KlmLayoutModule { }
